export default __webpack_public_path__ + "static/media/mears.c4671ea8.jpg";